import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Popconfirm, Table, Modal, Divider } from "antd";
import { DeleteFilled, EditOutlined } from "@ant-design/icons";
import qrActions from "../../../redux/qr/actions";
import QRUserForm from "./QRUserForm";
import PageHeader from "../../Common/PageHeader/PageHeader";
import "./index.css";

const { deleteQRUsers, saveQRUser, createQRUser } = qrActions;

const QRUserComponent = () => {
  const [toggleEditModal, setToggleEditModal] = useState(false);
  const [toggleAddQRUserModal, setToggleAddQRUserModal] = useState(false);
  const [user, setUser] = useState({});
  const { users } = useSelector((state) => state.qrReducer);

  const dispatch = useDispatch();

  const columns = [
    {
      title: "Име",
      dataIndex: "firstName",
      rowKey: "firstName",
      width: "25%",
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
      key: "firstName",
      render: (text) => <span className="qr-user-table-text">{text}</span>,
    },
    {
      title: "Фамилия",
      dataIndex: "lastName",
      rowKey: "lastName",
      width: "22%",
      sorter: (a, b) => a.lastName.localeCompare(b.lastName),
      key: "lastName",
      render: (text) => <span className="qr-user-table-text">{text}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      rowKey: "email",
      key: "email",
      width: "22%",
      render: (text) => <span className="qr-user-table-text">{text}</span>,
    },
    {
      title: "",
      dataIndex: "view",
      rowKey: "view",
      width: "5%",
      render: (text, user) => (
        <div className="qr-user-table-action-button">
          <Button
            color="primary"
            onClick={() => {
              setToggleEditModal(true);
              setUser(user);
            }}
            style={{ marginRight: "10px" }}
          >
            <EditOutlined />
          </Button>

          <Popconfirm
            title="Сигурен ли сте？"
            okText="Да"
            cancelText="Не"
            onConfirm={() => dispatch(deleteQRUsers(user.id))}
          >
            <Button className="qr-user-table-delete-icon">
              <DeleteFilled />
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div>
      <PageHeader text="QR Потребители" />
      <Button
        className="qr-user-scan-qr"
        onClick={() => setToggleAddQRUserModal(true)}
      >
        Създай потребител
      </Button>
      <div>
        <Table
          className="qr-user-table"
          style={{ cursor: "pointer" }}
          rowKey="email"
          dataSource={users}
          columns={columns}
          pagination={{ pageSize: 100 }}
        />
      </div>

      <Modal
        open={toggleEditModal || toggleAddQRUserModal}
        onClose={() => setToggleEditModal(false)}
        onCancel={() => {
          setToggleEditModal(false);
          setToggleAddQRUserModal(false);
        }}
        title={
          toggleEditModal === true ? (
            <div>
              <p className="qr-user-modal-title">Редактиране на потребител</p>
              <Divider className="qr-user-divider" />
            </div>
          ) : (
            <div>
              <p className="qr-user-modal-title">Създаване на потребител</p>
              <Divider className="qr-user-divider" />
            </div>
          )
        }
        footer={null}
      >
        <QRUserForm user={user} toggleEditModal={toggleEditModal} />
        <div style={{ textAlign: "center" }}>
          <Button
            style={{ marginRight: "8px" }}
            onClick={() => {
              if (toggleEditModal === true) {
                setToggleEditModal(false);
              } else {
                setToggleAddQRUserModal(false);
              }
              setUser({});
            }}
          >
            Отказ
          </Button>
          <Button
            type="primary"
            onClick={() => {
              if (toggleEditModal === true) {
                dispatch(saveQRUser(user));
                setToggleEditModal(false);
              } else {
                dispatch(createQRUser(user));
                setToggleAddQRUserModal(false);
              }
              setUser({});
            }}
          >
            {toggleEditModal === true ? "Запази" : "Създай"}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default QRUserComponent;
